import { ActivatedRoute } from '@angular/router';
import { BookServiceService } from './../services/book-service.service';
import { Component, OnInit, Input, ViewChild } from '@angular/core';

@Component({
  selector: 'app-edit-book',
  templateUrl: './edit-book.component.html',
  styleUrls: ['./edit-book.component.scss']
})
export class EditBookComponent implements OnInit {
book;
@ViewChild('form' , {static:true}) form: any ;

id = this.route.snapshot.paramMap.get("id");
  constructor(private as:BookServiceService , private route : ActivatedRoute) { }
  ngOnInit() {
    console.log(this.form);
    
  }

}
